import type { FeatureRealtimeHandler } from './featureRealtime';

import { referenceAssistantRealtimeHandler } from '@/features/reference-assistant/realtime';

/**
 * Every feature that follows its own hints on the inbox channel. A feature
 * adds its `/realtime` handler here; the prefixes must not overlap.
 */
export const FEATURE_REALTIME_HANDLERS: readonly FeatureRealtimeHandler[] = [
  referenceAssistantRealtimeHandler,
];
